var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoMicroBusVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1694_371)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.093,
    cy: 32.093,
    r: 20.093,
    fill: "#008000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1748 27.7384L43.908 31.8984C43.9691 32.0446 44.0004 32.2016 44 32.36V37C44 37.6628 43.4627 38.2 42.8 38.2H40.768C40.5915 39.4286 39.6262 40.394 38.3975 40.5704C36.8688 40.79 35.4515 39.7287 35.232 38.2H28.768C28.5915 39.4286 27.6262 40.394 26.3975 40.5704C24.8688 40.79 23.4515 39.7287 23.232 38.2H21.2C20.5372 38.2 20 37.6628 20 37V28.2C20 27.5373 20.5372 27 21.2 27H41.0668C41.5516 26.999 41.9891 27.2906 42.1748 27.7384ZM43 31.8L42 29.4H39.2V31.8H43ZM25.602 39.762C26.6845 39.9818 27.7402 39.2825 27.96 38.2C27.9867 38.0683 28.0001 37.9343 28 37.8C27.999 36.8496 27.3294 36.0311 26.398 35.842C25.3155 35.6222 24.2598 36.3215 24.04 37.404C23.8202 38.4865 24.5195 39.5422 25.602 39.762ZM28.768 37.4H29.6V34.2H20.8V37C20.8 37.2209 20.9791 37.4 21.2 37.4H23.232C23.4084 36.1713 24.3737 35.206 25.6024 35.0296C27.1312 34.81 28.5484 35.8713 28.768 37.4ZM33.6 37.4V33.4V29.4H30.4V37.4H33.6ZM37.602 39.762C38.6845 39.9818 39.7402 39.2825 39.96 38.2C39.9867 38.0683 40.0001 37.9343 40 37.8C39.999 36.8496 39.3294 36.0311 38.398 35.842C37.3155 35.6222 36.2598 36.3215 36.04 37.404C35.8202 38.4865 36.5195 39.5422 37.602 39.762ZM42.8 37.4C43.0209 37.4 43.2 37.2209 43.2 37V34.2H34.4V37.4H35.232C35.4084 36.1713 36.3737 35.206 37.6024 35.0296C39.1312 34.81 40.5484 35.8713 40.768 37.4H42.8ZM38.4 31.8V29.4H36V31.8H38.4ZM22.6666 31.6666H24.6666V29.6666H22.6666V31.6666ZM25.3333 31.6666H27.3333V29.6666H25.3333V31.6666Z",
    fill: "#FBFDFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1694_371",
    x: 3,
    y: 5,
    width: 60.186,
    height: 60.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1694_371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1694_371",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoMicroBusVerde);
export default __webpack_public_path__ + "static/media/iconoMicroBusVerde.b8e2ef12057af419f2bb950e48726297.svg";
export { ForwardRef as ReactComponent };